<app-breadcrumb [title]="'Términos y Condiciones'" [breadcrumb]="'Términos y Condiciones'"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <div class="page-title">
                            <h2>TÉRMINOS Y CONDICIONES</h2>
                        </div>
                        <br>
                        <div class="welcome-msg">
                            <h4>CONDICIONES DE COMPRA</h4>
                            <br>
                            <p>• Los precios se encuentran en pesos mexicanos e incluyen IVA.</p>
                            <p>• Las imágenes, características, especificaciones y precios son ilustrativos y pueden
                                variar o cambiar sin previo aviso.</p>
                            <p>• Todos los productos que se ofrecen, se encuentran sujetos a disponibilidad y hasta
                                agotar existencias.</p>
                            <br>
                            <br>
                            <h4>INVENTARIOS Y PRECIOS, CAMBIOS EN LOS INVENTARIOS Y PRECIOS</h4>
                            <br>
                            <p>• La disponibilidad de los productos, precios, marcas y modelos pueden variar de acuerdo
                                con la oferta del momento dispuesta por OPUSTREND Y/O GIGMAX.</p>
                            <p>• Todos los precios ya incluyen el Impuesto al Valor Agregado, el precio señalado en la
                                Oferta de Venta no es negociable y será debidamente respetado por “Usuario”.</p>
                            <br>
                            <br>
                            <h4>OPCIONES DE PAGO</h4>
                            <br>
                            <p>Métodos de pago: aceptamos las siguientes formas de pago en órdenes de
                                http://gigmax.mx/ </p>
                            <p>• Cualquier tarjeta de crédito o débito, ya sea Visa o Master Card.</p>
                            <p>A través de Conekta como sistema digital, así como cualquier tarjeta de crédito o débito
                                nacional, Visa o Master Card o American Express.</p>
                            <p>Proceso de autorización cuando realiza una orden: a través de Conekta, autentifica la
                                información de tu tarjeta, sin guardar ninguna información confidencial en el sitio.
                                Conekta valida la información con tu entidad financiera y así pueden aprobar o no
                                aprobar la transacción.</p>
                            <br>
                            <br>
                            <h4>OBTENER CONFIRMACIÓN DEL PEDIDO</h4>
                            <br>
                            <p>Para compras realizadas en línea a través de la página de http://GIGMAX.mx/ obtendrás
                                notificación de pedido vía correo electrónico o en línea, bajo la siguiente mecánica:
                            </p>
                            <p>1. Ingresa al apartado Mi Cuenta y elige Mis Pedidos.</p>
                            <p>2. Visualiza todas las órdenes de tu sesión para realizar el rastreo que quieres de tu
                                pedido.</p>
                            <p>3. Da clic en el botón Rastrear y Facturar pedido de la orden para su seguimiento.</p>
                            <br>
                            <br>
                            <h4>FACTURACIÓN</h4>
                            <br>
                            <p>Para la Facturación deberá ingresar a la página http://GIGMAX.mx/ y en la sección de
                                Mis Pedidos, hacer clic en el botón rastrear y facturar, sigue los pasos. La factura
                                deberá ser solicitada dentro del mes en curso en que se realizó la compra. No procederán
                                las solicitudes de facturas de compras de meses anteriores. Para poder generar tu
                                factura electrónica, el paquete deberá estar en estatus de "Entregado" y entonces podrás
                                solicitar tu factura.</p>
                            <p>Al solicitar su factura, será necesario que tenga a la mano y proporcione los siguientes
                                requisitos fiscales: RFC con homoclave, nombre completo o razón social, domicilio fiscal
                                completo (incluyendo calle, colonia, demarcación o municipio, estado y código postal),
                                deberá proporcionar su correo electrónico o mail en el que le llegará su factura en un
                                plazo no mayor a 5 días hábiles./p>
                                <br>
                                <br>
                            <h4>CONDICIONES DE LAS TRANSACCIONES Y ENVÍOS</h4>
                            <br>
                            <p>El tiempo estimado de entrega de un artículo será de 5 a 10 días hábiles siguientes a la
                                confirmación de tu compra. Las entregas se realizarán por pedido y no por partes. El
                                lugar de entrega del producto será el lugar físico que señalaste como tu domicilio de
                                entrega, el cual deberá ser en territorio nacional. En el caso de dudas o aclaraciones,
                                se deberá enviar un correo a contacto@GIGMAX.mx indicando el número de orden.</p>
                            <p>Los artículos están empaquetados para su cuidado y protección, por lo que no hay
                                envolturas especiales.</p>
                            <br>
                            <br>
                            <h4>COSTOS Y TIEMPOS DE ENVÍO</h4>
                            <br>
                            <p>OPUSTREND Y/O GIGMAX garantiza que todos sus envíos llegarán a la dirección que el
                                usuario determine en territorio nacional y se encontrará sujeto a las condiciones que se
                                señalan en la propia guía de envío de la empresa transportista, por lo que OPUSTREND Y/O
                                GIGMAX es ajeno a las restricciones, ya sea porque la zona sea considerada de alto
                                riesgo o por horario de entrega. El proceso de envío se inicia considerando la hora del
                                día en la que se realiza la confirmación de la compra, dependiendo de esto, tu orden
                                puede ser procesada el mismo día o hasta el siguiente día hábil. Los días hábiles son de
                                lunes a viernes entre 9:00 am y 6:00 pm, conforme a la ley, no se consideran días
                                hábiles los siguientes: 1° de enero, lunes correspondiente al 5 de febrero, lunes
                                correspondiente al 21 de marzo, jueves y viernes santos, 1° de mayo, 16 de septiembre,
                                lunes correspondiente al 20 de noviembre y 25 de diciembre. Envíos a toda la República
                                Mexicana.</p>
                            <br>
                            <br>
                            <h4>GASTOS DE ENVÍO</h4>
                            <br>
                            <p>El precio total del gasto de envío está incluido en el precio final de pago (envío
                                gratis).</p>
                            <br>
                            <br>
                            <h4>SEGUIMIENTO DE UNA ORDEN</h4>
                            <br>
                            <p>Para revisar la situación de tu orden: 1. Ingresa a Mi cuenta, 2. Elige Mis Pedidos, 3.
                                Elige Rastrear Y Facturar para el seguimiento del pedido, 4. Visualiza el estatus de tu
                                pedido, fecha de entrega, núm. De guía y paquetería, así mismo, podrás ver los detalles
                                del envío y el estatus actual. Los detalles proceden del sitio de OPUSTREND Y/O GIGMAX
                                vinculada a la mensajería responsable de cada entrega. </p>
                            <br>
                            <br>
                            <h4>CONTÁCTANOS</h4>
                            <br>
                            <p>Para preguntas, dudas o comentarios sobre el estado de tu orden o la disponibilidad de un
                                artículo, contáctanos a: contacto@GIGMAX.mx </p>
                            <br>
                            <br>
                            <h4>GARANTÍAS</h4>
                            <br>
                            <p>La Garantía de los equipos es de 15 días con OPUSTREND Y/O GIGMAX y un año directamente
                                con el proveedor a partir de la fecha de compra, siempre y cuando el Cliente cumpla con
                                los lineamientos físicos y eléctricos que determina el fabricante del equipo.</p>
                            <p>Para hacer efectiva la garantía del equipo celular se debe presentar el número de orden,
                                factura y/o carta factura y boleta de garantía con los datos IMEI, marca y modelo,
                                enviando un correo electrónico a: contacto@GIGMAX.mx </p>
                            <p>La garantía no será válida en las siguientes circunstancias:</p>
                            <p>• Daños por análisis, operación, mantenimiento, ajuste o cualquier alteración o
                                modificación causada por personal no autorizado.</p>
                            <p>• Defecto o daño causado por el mal uso del producto o en condiciones distintas al manejo
                                del mismo, es decir, uso inadecuado en forma intencional o imprudencial que afecte el
                                aspecto externo y operación del equipo o accesorio; por ejemplo: fuerzas externas
                                excesivas, caídas, humedad, etc.</p>
                            <p>• Daño a la antena del equipo, a menos que sea causado por defecto de fabricación.</p>
                            <p>• Cuando el equipo o accesorio no tienen las etiquetas o números de serie mecánica y
                                electrónica, así como la marca del mismo.</p>
                            <p>• Si los accesorios están rotos o fueron utilizados indebidamente.</p>
                            <br>
                            <br>
                            <h4>CONDICIONES</h4>
                            <br>
                            <p>Antes de usar el producto, el consumidor se compromete a leer el instructivo para dar la
                                utilidad precisa a su producto. Para hacer válida la garantía, el cliente debe contar
                                con su número de pedido y el producto con el empaque.</p>
                            <p>La devolución nunca será en efectivo.</p>
                            <p>Esta Garantía no procede en los siguientes casos:</p>
                            <p>• Si el producto no ha sido operado conforme a lo estipulado por el instructivo anexo.
                            </p>
                            <p>• Cuando el producto ha sido utilizado en condiciones distintas para las que fue
                                diseñado.</p>
                            <p>• Si el producto ha tratado de ser reparado por personal no autorizado.</p>
                            <br>
                            <br>
                            <h4>POLÍTICAS DE COMPRAS</h4>
                            <br>
                            <p>OPUSTREND Y/O GIGMAX se reserva el derecho de cancelar cualquier pedido debido al uso
                                no autorizado o las alteraciones de cualquier producto publicado. Así mismo, el
                                modificar o cancelar cualquier precio debido a errores del sistema o problemas
                                imprevistos. Pueden aplicarse otras restricciones.</p>
                            <br>
                            <br>
                            <!--<h4><strong>¡CONOCE TODO!</strong></h4>
                            <br>
                            <p>Recibe las ofertas, noticias y descuentos exclusivos cada semana.</p>
                            <br>
                            <br>-->
                            <p>En términos del artículo 56 de la Ley Federal de Protección al Consumidor, el consumidor
                                podrá revocar su consentimiento dejando sin efectos la compra del producto, quedando
                                obligado OPUSTREND Y/O GIGMAX a devolver al consumidor el 100% del precio pagado,
                                siempre y cuando, se reúnan los siguientes requisitos:</p>
                            <p>1. Que se notifique a OPUSTREND Y/O GIGMAX la revocación del consentimiento dentro de
                                los cinco (5) días naturales siguientes a aquel en que haya recibido el producto, lo que
                                deberá hacerse de manera fehaciente en el domicilio ubicado en Av. Insurgentes Sur 1666
                                Col. Florida, 01030, Álvaro Obregón, Ciudad de México, o bien, mediante el envío de un
                                correo electrónico a la siguiente dirección: contacto@GIGMAX.mx </p>
                            <p>2. Que el producto no haya sido abierto y se encuentre en perfectas condiciones,
                                incluyendo el empaque original y la envoltura.</p>
                            <p>3. Que una vez notificado a OPUSTREND Y/O GIGMAX la revocación del consentimiento, el
                                consumidor acuda al domicilio previamente señalado a devolver físicamente el producto,
                                lo que deberá hacerse en días y horas hábiles, mismos que comprenden de lunes a viernes
                                de 9:00 a.m. a 5:00 p.m.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->